import Parse from "parse";

Parse.initialize(
  process.env.REACT_APP_PARSE_SERVER_APP_ID,
  process.env.REACT_APP_PARSE_SERVER_JS_ID
);
Parse.serverURL = process.env.REACT_APP_PARSE_SERVER_URI;

export default Parse;
